/**
 * GraphService - Server API operations
 *
 * Handles: server health check, preset management.
 * View state computation is in src/graph/viewState.ts
 * Graph mutations are handled by RuntimeStore.
 */


import { ApiBaseWeb } from '../ui/services/ApiBaseWeb';

/**
 * PresetService - manages server API calls for the UI
 */
class PresetService extends ApiBaseWeb {
  /**
   * Wait for server to be ready (polls /health endpoint)
   */


  // ─────────────────────────────────────────────────────────────
  // Preset operations
  // ─────────────────────────────────────────────────────────────

  async addDefinitionPreset(
    definitionId: string,
    name: string,
    values: Record<string, any>,
    description?: string
  ): Promise<void> {
    await this.post('definition/addPreset', { definitionId, name, values, description });
  }

  async removeDefinitionPreset(definitionId: string, name: string): Promise<void> {
    await this.post('definition/removePreset', { definitionId, name });
  }

  async saveDefinitionUserPreset(
    definitionId: string,
    name: string,
    params: Record<string, any>
  ): Promise<void> {
    await this.post('definition/saveUserPreset', { definitionId, name, params });
  }

  async deleteDefinitionUserPreset(definitionId: string, name: string): Promise<void> {
    await this.post('definition/deleteUserPreset', { definitionId, name });
  }

  async savePresetFromNode(instanceId: string, nodeId: string, name: string): Promise<boolean> {
    try {
      const data = await this.post<{ success: boolean }>('preset/saveFromNode', { instanceId, nodeId, name });
      return data.success === true;
    } catch {
      return false;
    }
  }
}

// Singleton instance
export const presetService = new PresetService();
